import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminLayout } from '@/components/Layout/Layout';
import { EditButton, RecordField, TextField } from '@/shared/ui/Fields/Fields';
import { DataGrid } from '@/components/DataGrid/DataGrid';
import api from '@/shared/api/api';
import { useFetch } from '@/shared/hooks/useFetch';
import Button from '@/shared/ui/Buttons/Button';

function EmployeeList() {
    const navigate = useNavigate();
    const { data: records, refresh } = useFetch(
        () => api.employees.getEmployeesApiEmployeesGet(),
        [],
        []
    );

    const handleDelete = async (id: number) => {
        await api.employees.deleteEmployeesApiEmployeesIdDelete(id);
        refresh();
    };

    return (
        <AdminLayout>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
                <Button onClick={() => navigate('/employees/create')}>Новый сотрудник</Button>
            </div>
            <DataGrid title="Сотрудники" records={records}>
                <TextField key="id" label="№" />
                <TextField key="name" label="ФИО" />
                <TextField key="email" label="Почта" />
                <EditButton key="id" urlPrefix="/employees/update/" label="Редактировать" />
                <RecordField
                    label="Удалить"
                    render={(record) => (
                        <div
                            className="text-14 cursor-pointer red"
                            onClick={() => handleDelete(record?.id)}
                        >
                            Удалить
                        </div>
                    )}
                />
            </DataGrid>
        </AdminLayout>
    );
}

export default EmployeeList;
